import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfile, vendorLogout } from '../api/vendorApi';
import { VpSpinner } from '../components/VpUI';
import VpIcon from '../components/VpIcon';

const Field = ({ label, value }: { label: string; value?: any }) => (
	<div className='vp-profile-field'>
		<div className='vp-profile-field-label'>{label}</div>
		<div className='vp-profile-field-value'>{value || '—'}</div>
	</div>
);

const VendorProfile = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [p, setP] = useState<any>(null);
	const [error, setError] = useState('');

	useEffect(() => {
		(async () => {
			try {
				const data = await getProfile();
				setP(data);
			} catch (err: any) {
				setError(err?.apiMessage || 'Could not load your profile.');
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	const doLogout = () => {
		vendorLogout();
		navigate('/vendor-portal/login', { replace: true });
	};

	if (loading) return <VpSpinner />;
	if (error) return <div className='vp-alert vp-alert-error'>{error}</div>;

	const initials = (p?.name || 'V')
		.split(' ')
		.map((w: string) => w[0])
		.slice(0, 2)
		.join('')
		.toUpperCase();

	return (
		<div style={{ maxWidth: 860 }}>
			{/* Header card — everything on white so text is always readable. */}
			<div className='vp-card vp-profile-head'>
				<div className='vp-profile-avatar'>{initials}</div>
				<div className='vp-profile-head-info'>
					<div className='vp-profile-name-row'>
						<h2>{p?.name || 'Vendor'}</h2>
						<span className='vp-badge vp-badge-confirmed'>Portal Active</span>
					</div>
					<div className='vp-profile-head-meta'>
						{p?.email && (
							<span>
								<VpIcon name='profile' size={14} /> {p.email}
							</span>
						)}
						{p?.contact_no && (
							<span>
								<VpIcon name='receipt' size={14} /> {p.contact_no}
							</span>
						)}
					</div>
				</div>
				<button
					type='button'
					className='vp-btn vp-btn-ghost vp-input-sm'
					onClick={doLogout}>
					<VpIcon name='logout' size={16} /> Logout
				</button>
			</div>

			<div className='vp-grid-2 vp-mt-16'>
				{/* Company details */}
				<div className='vp-card'>
					<div className='vp-card-head'>
						<h3>Company Details</h3>
					</div>
					<div className='vp-card-pad'>
						<div className='vp-profile-grid'>
							<Field label='Vendor Name' value={p?.name} />
							<Field label='Email' value={p?.email} />
							<Field label='Contact No.' value={p?.contact_no} />
							<Field label='GST' value={p?.gst} />
							<Field label='PAN' value={p?.pan} />
						</div>
						<Field label='Address' value={p?.address} />
					</div>
				</div>

				{/* Bank details */}
				<div className='vp-card'>
					<div className='vp-card-head'>
						<h3>Bank Details</h3>
					</div>
					<div className='vp-card-pad'>
						<Field label='Bank Name' value={p?.bankName} />
						<div className='vp-profile-grid'>
							<Field label='Account No.' value={p?.bankAccountNo} />
							<Field label='IFSC Code' value={p?.ifscCode} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default VendorProfile;
